<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4 text-center" is-centered>
        <h1 class="text-text-neutral-primary font-medium">
          {{ t('ancillaries.medicalInsurance.title') }}
        </h1>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="space-y-4 px-4 pb-4">
        <p class="text-text-neutral-primary text-sm">
          {{ t('ancillaries.medicalInsurance.details.description') }}
        </p>
        <button
          type="button"
          class="flex w-full items-center justify-between"
          @click="
            bottomSheet.show(medicalInsuranceConfig.CONDITIONS_BOTTOM_SHEET)
          "
        >
          <span class="text-text-neutral-primary text-sm font-medium">
            {{ t('ancillaries.medicalInsurance.details.conditionsTitle') }}
          </span>
          <ChevronIcon class="text-text-positive-primary h-6 w-6" />
        </button>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';

  import ChevronIcon from '@/assets/images/chevron-arrow-24x24.svg?component';

  import { medicalInsuranceConfig } from '../config';

  defineProps<{
    name: string;
  }>();

  const { t } = useI18n();

  const bottomSheet = controllerModel.useBottomSheet();
</script>
